// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x7x105F0Ex0A7R {
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: var(--ds-space-0, 0px);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  color: var(--accent-text, var(--ds-icon-subtle, #626f86));
}
.x7x105F0Ex0A7R:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.x7x105F0Ex0A7R:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
@media print {
  .x7x105F0Ex0A7R {
    display: none;
  }
}
.l5j3OcOLJ1Ljv6 {
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: var(--ds-space-0, 0px);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
}
@media print {
  .l5j3OcOLJ1Ljv6 {
    display: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listEditButton": `x7x105F0Ex0A7R`,
	"listEditButton--isSelected": `l5j3OcOLJ1Ljv6`
};
export default ___CSS_LOADER_EXPORT___;
